// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TFT6","colBig":"styles_colBig__1-YGB","colSmall":"styles_colSmall__TGLNC"};